import dayjs from 'dayjs';

const isLeapYear = require('dayjs/plugin/isLeapYear');

dayjs.extend(isLeapYear);

function parseDate(date) {
  if (!date) return null;

  const [day, month, year] = date.split('.');
  if (!day || !month || !year) return null;
  const newDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  const isNumber = (value) => !Number.isNaN(Number(value));
  if (isNumber(new Date(newDate).getTime())) {
    if (!dayjs(year).isLeapYear() && day === '29' && month === '02') {
      return null;
    }
    if (Number(day) > dayjs(month).daysInMonth() && !(dayjs(year).isLeapYear() && day === '29' && month === '02')) {
      return null;
    }
    return newDate;
  }
  return null;
}

export default parseDate;
